/**
* HC Angled Sections JS
* -----------------------------------------------------------------------------
*
* All the JS for the HC Angled Sections component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hc-angled-sections',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.hc-angled-sections' ).each( function( key, val ) {
        const angleBlockLeft = $( this ).find( '.angle-block--left' )[0];
        const angleBlockRight = $( this ).find( '.angle-block--right' )[0];

        let start = 'top top-=' + ( val.offsetLeft - window.innerWidth * 1.5 ) * ( window.maxWidth / ( window.maxWidth - window.innerWidth ) );
        let end = '+=' + ( val.offsetWidth * 1.5 ) * ( window.maxWidth / ( window.maxWidth - window.innerWidth ) );
        if ( window.innerWidth < 1024 ) {
          start = 'top 75%';
          end = 'bottom 75%';
        }

        // const tl = gsap.timeline( {
        //   scrollTrigger: {
        //     trigger: val,
        //     start: () => start,
        //     end: () => end,
        //     toggleClass: {targets: val, className: 'active'},
        //     scrub: 1,
        //     onEnter: ( x, y, z ) => {
        //       if ( $( val ).find( '.device-video' ).length ) {
        //         image.play();
        //       }
        //     },
        //   },
        // } );

        let vidPlayed = false;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            start: () => start,
            end: () => end,
            // toggleClass: {targets: val, className: 'active'},
            onUpdate: ( self ) => {
              if ( $( val ).find( '.device-video' ).length && !vidPlayed && self.progress > 0.6 ) {
                $( val ).find( '.device-video' )[0].play();
                vidPlayed = true;
              }
            },
            scrub: 1,
          },
        } );
        if ( window.innerWidth > 1024 ) {
          if ( angleBlockLeft ) {
            tl.to( angleBlockLeft, {x: '-15%', y: '0%', ease: 'linear'}, 0 );
          }
          if ( angleBlockRight ) {
            tl.to( angleBlockRight, {x: '-15%', y: '0%', ease: 'linear'}, 0 );
          }
        } else {
          if ( angleBlockLeft ) {
            if ( $( angleBlockLeft ).hasClass( 'is-right' ) ) {
              tl.to( angleBlockLeft, {x: '0%', y: '-20%', ease: 'linear'}, 0 );
            } else {
              tl.to( angleBlockLeft, {x: '0%', y: '-2%', ease: 'linear'}, 0 );
            }
          }

          if ( angleBlockRight ) {
            tl.to( angleBlockRight, {x: '0%', y: '-2%', ease: 'linear'}, 0 );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hc-angled-sections', COMPONENT );
} )( app );
